<template>
  <el-dialog :visible="visible" @open="open" @close="close" fullscreen :close-on-click-modal="false" append-to-body class="editor">
    <!-- <el-row slot="title">病历质控</el-row> -->
    <el-row v-if="mrMain" slot="title">
      <el-col :span="21">
        <small class="left-pad">患者：</small>
        <el-link type="primary" class="toolbar_link" @click="meta.showTreats = true">{{ mrMain.patientName }} </el-link>
        <small class="left-pad">门诊号：</small>
        <el-link type="info" class="toolbar_link" :underline="false">
          {{ mrMain.opNo }}
          <small class="left-pad">
            {{ mrMain.deptCode | dictText("Dept") }}
            {{ mrMain.doctorName }}
          </small>
        </el-link>
        <small class="left-pad">文书：</small>
        <el-popover v-if="mr.curr" placement="bottom-start" trigger="hover">
          <p v-for="item in mr.items" :key="item.id">
            <i class="el-icon-success success" v-if="item.qcState == '通过'" />
            <i class="el-icon-error danger" v-if="item.qcState == '不通过'" />
            <i class="el-icon-warning primary" v-if="item.qcState == '待质控'" />
            <el-link class="toolbar_link left-pad" @click="switchMr(item)" :disabled="mr.curr.id == item.id">{{ item.tmplCode | dictText("MrTemplate") }}</el-link>
            <small v-if="item.editingUserCode" title="编辑中！已锁定！" class="left-pad"><i class="el-icon-edit" /> {{ item.editingUserName }}</small>
          </p>
          <el-link slot="reference" type="info" class="toolbar_link" :underline="false">
            {{ mr.curr.tmplCode | dictText("MrTemplate") }}
          </el-link>
        </el-popover>
        <el-link type="info" v-else class="toolbar_link" :underline="false">
          <span>当前病历中不含待质控文书</span>
        </el-link>
      </el-col>
      <el-col :span="3"> </el-col>
    </el-row>
    <el-container class="f-h">
      <el-main ref="main">
        <el-row ref="editor" class="f-h" v-loading="meta.loading" />
      </el-main>
      <el-aside :width="asideWidth" style="padding: 0.5rem" v-show="showAside">
        <el-collapse v-model="actName">
          <el-collapse-item title="审批记录" name="1">
            <b slot="title"> 审批记录 </b>
            <el-timeline>
              <el-timeline-item placement="top" v-for="(log, index) in entity.auditLogs ? JSON.parse(entity.auditLogs) : []" :key="index" :type="log.auditResult == '未通过' ? 'danger' : 'success'" :timestamp="log.auditDate">
                {{ log.auditName }}： {{ log.auditResult }}
                <p v-if="log.auditReason">{{ log.auditReason }}</p>
              </el-timeline-item>
            </el-timeline>
            <el-empty v-show="!entity.auditLogs || JSON.parse(entity.auditLogs).length == 0" description="无数据"></el-empty>
          </el-collapse-item>
        </el-collapse>
      </el-aside>
    </el-container>
    <span slot="footer" class="dialog-footer" style="height: 1px">
      <div v-if="mr.curr" class="pull-left">
        <el-button-group>
          <!-- <el-button type="primary" :icon="showAside ? 'el-icon-reading' : 'el-icon-notebook-1'" @click="switchSideShow"></el-button> -->
          <el-button type="danger" icon="el-icon-plus" @click="addComment" size="small">批注</el-button>
        </el-button-group>
        <small class="left-pad"><b>文书质控结果：</b></small>
        <el-radio-group v-model="mr.curr.qcState" class="left-pad">
          <el-radio label="通过"><b>通过</b></el-radio>
          <el-radio label="不通过"><b>不通过</b></el-radio>
        </el-radio-group>
      </div>
      <el-button type="primary" @click="submit" class="left-pad">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import editorUtils from "@/common/editorUtils";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      mrMain: Object,
    },
    data() {
      return {
        comments: [],
        entity: {},
        actName: "1",
        showAside: false,
        asideWidth: "17rem",
        mr: {
          items: [],
          curr: null,
        },
        meta: {
          loading: false,
          saving: false,
        },
        qc: {
          log: null,
          detail: null,
        },
      };
    },
    computed: {
      ...mapGetters(["Enum", "dict", "user"]),
    },
    watch: {
      showAside() {
        this.$nextTick(() => {
          let oRet = this.$editor.GetSize();
          oRet = this.$editor.SetSize(this.$refs.main.$el.clientWidth, this.$refs.main.$el.clientHeight - 4);
        });
      },
    },
    mounted() {
      try {
        this.$editor.CloseEditor();
      } catch (error) {
        console.log(error);
      }

      // 文件打开事件
      this.$editor.NsoFileOpenCompleted = () => {
        this.$editor.SetToolBarsVisible("All", false); // 编辑栏
        this.$editor.SetLeftPanelVisible(true); // 左侧栏
        this.$editor.SetRPropWindowVisible(false); //　右侧栏
        this.$editor.SetRulersVisible(false); //　标尺
        this.$editor.SetEditMode(6); // 弱只读
        // let oRet = _this.$editor.InitEvents();
        // //2，可编辑；6-弱只读
        // _this.$editor.SetViewProportion(3);
        this.$editor.SetUserInfo({
          UserCode: this.user.code,
          UserName: this.user.name,
          Department: this.user.deptName,
          TrackColor: "00BFFF",
          TrackMark: 0,
        });
      };
    },
    methods: {
      auditTagType(f) {
        switch (f) {
          case "待质控":
            return "warning";
          case "通过":
            return "success";
          case "未通过":
            return "danger";
          default:
            return "primary";
        }
      },
      open() {
        this.mr = {
          items: [],
          curr: null,
        };
        this.$nextTick(() => {
          // 创建编辑器
          let oRet = editorUtils.createDomEditor(this.$editor, this.$refs.editor);
          if (oRet.id) {
            this.$message.error("编辑器创建失败！");
            console.log("编辑器创建失败！", oRet);
            this.$editor = new NsoOffice();
          }
          this.meta.loading = true;
          this.$api.Mr.query({ mainId: this.mrMain.id })
            .then((res) => {
              this.mr.items = res.items.filter((i) => i.qcState != "未提交");
              if (!this.mr.items.length) {
                throw "当前病历不存在待审批的文书！";
              }
              return this.$api.QcLog.getDefault(this.mrMain.id);
            })
            .then((res) => {
              this.qc.log = res;
              this.switchMr(this.mr.items[0]);
            })
            .catch((err) => {
              this.$message.error(err);
              console.log(err);
            })
            .finally(() => {
              this.meta.loading = false;
            });
        });
      },
      switchMr(item) {
        this.meta.loading = true;
        if (this.mr.curr) {
          this.saveMr();
        }
        // 锁定文书
        this.$api.Mr.qcLock(item.id)
          .then((res) => {
            this.mr.curr = res;
            // 获取文书质控详细
            return this.$api.QcLogDetail.getDefault(this.qc.log.id, item.id);
          })
          .then((res) => {
            this.qc.detail = res;
            // 获取最后的版本
            return this.$api.MrVer.last(item.id);
          })
          .then((res) => {
            if (!res) {
              throw "找不到任何版本！";
            }
            if (res.ifEditing) {
              throw "存在编辑中尚未提交的版本！";
            }
             if (!res.content) {
              throw "带指控的版本内容为空！";
            }
            this.mr.ver = res;
            let oRet = this.$editor.OpenFile(res.content, 2, 2);
            if (oRet.id) {
              console.log("编辑器加载文书失败！", oRet);
              throw "加载文书失败！";
            }
          })
          .catch((err) => {
            this.$message.error(err + "请尝试打开其他文书！");
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      saveFile() {
        return new Promise((resolve, reject) => {
          let oRet = this.$editor.SaveFile("bin");
          if (oRet.id != 0) {
            reject(`编辑器保存失败: ${oRet.desc}`);
            console.log("编辑器保存失败！", oRet);
          } else {
            resolve(oRet.base64);
          }
        });
      },
      saveMr() {
        return new Promise((resolve, reject) => {
          let { qcState } = this.mr.curr;
          this.saveFile()
            .then((res) => {
              this.mr.ver.content = res;
              // 保存版本，后端会自动联动保存文书，此处不需要单独保存文书了
              return this.$api.MrVer.audit(this.mr.ver, qcState);
            })
            .then((res) => {
              if (this.qc.detail.content) {
                if (this.mr.curr.qcState == "通过") {
                  this.qc.detail.errLevel = "警告";
                } else if (this.mr.curr.qcState == "不通过") {
                  this.qc.detail.errLevel = "严重";
                }
              }
              // 保存文书质控详细
              return this.$api.QcLogDetail.save(this.qc.detail);
            })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              this.$message.error(err);
              console.log(err);
              reject(err);
            });
        });
      },
      close() {
        try {
          this.$api.MrMain.unlock(this.mrMain.id);
          this.$editor.CloseEditor();
        } catch (error) {
          console.log(error);
        }
        this.$emit("update:visible", false);
      },
      submit() {
        this.saveMr().then((res) => {
          // 解锁病历，会关联自动解锁所有文书
          this.$api.MrMain.unlock(this.mrMain.id)
            .then((res) => {
              {
                // 保存病历质控记录
                this.qc.log.qcState = res.qcState;
                this.qc.log.qcTime = this.$utils.Dt.now();
                this.qc.log.qcUserCode = this.user.code;
                this.qc.log.qcUserName = this.user.name;
                return this.$api.QcLog.save(this.qc.log);
              }
            })
            .then((res) => {
              this.$message.success("提交成功！");
              this.$emit("submited");
              this.$emit("update:visible", false);
            })
            .catch((err) => {
              this.$message.error(err);
            });
        });
      },
      switchSideShow() {
        this.showAside = !this.showAside;
        // this.$editor.ShowPostilListWindow(this.showAside)
      },
      addComment() {
        this.$editor.ShowPostilListWindow(true);
        let _this = this;
        this.$prompt("", "批注意见", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            try {
              let oRet = _this.$editor.AddPostil(value, this.$utils.Dt.now());

              if (oRet.id != 0) {
                console.log("AddPostil:" + oRet.desc);
              } else {
                this.comments.push(oRet);
                let errs = [];
                if (this.qc.detail.content) {
                  errs = JSON.parse(this.qc.detail.content);
                }
                errs.push({ desc: value, user: this.user.name, date: this.$utils.Dt.now() });
                this.qc.detail.content = JSON.stringify(errs);
                this.$editor.ShowPostilListWindow(true);
                if (this.mr.curr.qcState != "通过" && this.mr.curr.qcState != "不通过") {
                  this.mr.curr.qcState = "不通过";
                }
              }
            } catch (error) {
              console.log("error:", error);
            }
          })
          .catch(() => {});
      },
    },
  };
</script>
<style>
  .toolbar_link {
    font-size: large;
    font-weight: bold;
  }
</style>
